import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgOctagonAlert = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 15.6H12.009M12 8.4V12M14.9808 3C15.4582 3.0001 15.9159 3.18981 16.2534 3.5274L20.4726 7.7466C20.8102 8.08409 20.9999 8.54185 21 9.0192V14.9808C20.9999 15.4582 20.8102 15.9159 20.4726 16.2534L16.2534 20.4726C15.9159 20.8102 15.4582 20.9999 14.9808 21H9.0192C8.54185 20.9999 8.08409 20.8102 7.7466 20.4726L3.5274 16.2534C3.18981 15.9159 3.0001 15.4582 3 14.9808V9.0192C3.0001 8.54185 3.18981 8.08409 3.5274 7.7466L7.7466 3.5274C8.08409 3.18981 8.54185 3.0001 9.0192 3H14.9808Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgOctagonAlert);
export { ForwardRef as ReactComponent };
